<div class="footer">
    <ul class="cetelem-line">
        <li>
            <span class="line-text">
                {{ financing | translate }}
            </span>

            <span class="text-footer-cetelem-vertical-step">
                {{ cetelem | translate }}
            </span>
        </li>
    </ul>

    <ul class="link-line">
        <li>
            <a class="line-text" href="https://www.cetelem.es/politica-de-cookies" target="_blank">{{ cookiesPolicy | translate }}</a>
        </li>

        <li>
            <a class="line-text" href="https://www.cetelem.es/informacion-legal" target="_blank">{{ legalInformation | translate }}</a>
        </li>

        <li>
            <a class="line-text" href="https://www.cetelem.es/proteccion-de-datos" target="_blank">{{ dataProtection | translate }}</a>
        </li>
    </ul>

    <ul>
        <li>
            <span class="line-text">
                {{ exitStore | translate }}
            </span>
        </li>
    </ul>
</div>
